const state = () => ({
    features: "",
    tariffId: 0,
});

const getters = {
    getFeatures: (state) => state.features,
    getTariffId: (state) => state.tariffId,
};

const actions = {
    processFeatures({ commit }, payload) {
        commit("setFeatures", payload);
    },
    processTariffId({ commit }, payload) {
        commit("setTariffId", payload);
    },
};

const mutations = {
    setFeatures(state, features) {
        state.features = features.split(",");
    },
    setTariffId(state, id) {
        state.tariffId = id;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
